import React from 'react';
import _get from 'lodash/get';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import AvatarIcon from '@lib/assets/icons/avatar.svg?react';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Typography from '@lib/components/Typography/Typography';
import { SelectPanelOptionRendererProps } from '../types';
import { getOptionLabel } from '../utils';
import styles from '../SelectPanel.module.scss';

export function UserOption({
  option,
  isSelected,
  isMulti,
}: SelectPanelOptionRendererProps): React.ReactElement {
  const { t } = useTranslation();
  const { data } = option || {};
  const email = _get(data, 'email');
  const url =
    _get(data, 'avatarAttached.urls.small') ||
    _get(data, 'avatarAttached.urls.original');

  return (
    <div
      className={classNames(styles.userOption, {
        active: isSelected,
        [styles.optionWithCheckbox]: isMulti,
      })}
    >
      {isMulti && (
        <span className={styles.optionCheckbox}>
          <MaterialIcon
            icon={isSelected ? 'check_box' : 'check_box_outline_blank'}
            size="md-18"
          />
        </span>
      )}
      <span className={styles.userOptionIcon}>
        {url ? <img src={url} alt="" /> : <AvatarIcon />}
      </span>
      <div>
        {getOptionLabel(option, t)}
        {email && (
          <Typography variant="caption" className={styles.userOptionEmail}>
            {email}
          </Typography>
        )}
      </div>
    </div>
  );
}
